import { queries } from '../lib/supabase/queries';

export const galleryService = {
  async getAll() {
    return queries.gallery.getAll();
  },

  async getPublished() {
    return queries.gallery.getPublished();
  },

  async create(item) {
    return queries.gallery.create(item);
  },

  async update(id, updates) {
    return queries.gallery.update(id, updates);
  },

  async delete(id, storagePath = '') {
    return queries.gallery.delete(id, storagePath);
  },
};

export default galleryService;
